import { api } from '@api'
import { useQuery } from '@tanstack/react-query'
import { Category } from './usePaginateCategories'

interface GetCategoryByIdResponse {
  category: Category
}

const fetchCategoryById = async (id: string): Promise<Category> => {
  const { data } = await api.get<GetCategoryByIdResponse>(`/categories/${id}`)
  return data.category
}

export const useGetCategoryById = (id: string) => {
  return useQuery<Category>({
    queryKey: ['category', id],
    queryFn: () => fetchCategoryById(id),
    enabled: !!id,
  })
}

